import axios from 'axios'

import {
  createTheParametersOfTheUrl,
} from '../../plugins/helper'
import * as types from '../mutation-types'

const doToArrayObject = datos => {
  const term = []
  Object.keys(datos).forEach(key => {
    const id = datos[key].id
    const text = datos[key].name
    term.push({ value: id, text })
  })

  return term
}

// state
export const state = {
  loading: true,
  AccountingAccounts: [],
  error: null,
}

// mutations
export const mutations = {
  [types.GET_ACCOUNTING_ACCOUNTS_START] (state) {
    state.loading = true
    state.AccountingAccounts = []
    state.error = null
  },

  [types.GET_ACCOUNTING_ACCOUNTS_SUCCESS] (state, { data }) {
    state.loading = false
    state.AccountingAccounts = doToArrayObject(data)
    state.error = null
  },

  [types.GET_ACCOUNTING_ACCOUNTS_ERROR] (state, { error }) {
    state.loading = false
    state.AccountingAccounts = []
    state.error = error
  },
}

export const actions = {
  /**
   * @param {Object}
   * @param {Object} payload
   */
  async getAccountingAccounts ({ commit }, payload) {
    try {
      commit(types.GET_ACCOUNTING_ACCOUNTS_START)
      const href = createTheParametersOfTheUrl(payload)
      const { data } = await axios.get(`/api/administrations/accounting_accounts/list${href}`)

      commit(types.GET_ACCOUNTING_ACCOUNTS_SUCCESS, { data: data.data })
    } catch (e) {
      commit(types.GET_ACCOUNTING_ACCOUNTS_ERROR, { error: null })
    }
  },
}

// getters
export const getters = {
  loadingAccountingAccounts: state => state.loading,
  accountingAccounts: state => state.AccountingAccounts,
  errorAccountingAccounts: state => state.error,
}
